// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.rowExpandedImg {*/
/*    text-align: center;*/
/*    cursor: pointer;*/
/*    width: 100%;*/
/*    display: inline-block;*/
/*}*/

.tr-styles_tdInner__erpMF {
    display: flex;
    text-align: left;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    grid-gap: 6px;
}

.tr-styles_fixedRow__qe41B {
    position: sticky !important;
    top: 28px;
    z-index: 9;
    background: var(--white-active);
}

.tr-styles_tdGroupTable__UL8Ob {
    position: relative;
    padding: 20px;
    width: 100%;
    height: 100%;
    min-width: 100%;
    /*display: flex;*/
    /*flex-direction: column;*/
}

.tr-styles_tdGroupRow__UiP8p {
    position: relative;
}

.tr-styles_tdGroup__Qglm\\+ {
    position: relative;
    padding: 0 10px;
}

.tr-styles_tdGroup__Qglm\\+:last-child {
    padding-right: 0;
}

.tr-styles_tdGroup__Qglm\\+:last-child:before {
    width: calc(100% - 10px);
}

.tr-styles_tdGroup__Qglm\\+:before,
.tr-styles_tdGroupRow__UiP8p:before {
    content: '';
    position: absolute;
    top: 0;
    left: 10px;
    width: calc(100% - 20px);
    height: 100%;
}

.tr-styles_tdGroup__Qglm\\+:not(:first-child):before,
.tr-styles_tdGroupRow__UiP8p:before {
    opacity: 0.2;
    background: var(--light-grey);
}

.tr-styles_tdGroupRow__UiP8p:first-child:before {
    left: 0;
    width: calc(100% - 10px);
}

.tr-styles_tdGroupRow__UiP8p:last-child:before {
    width: calc(100% - 10px);
}

.tr-styles_tdGroupRow__UiP8p.tr-styles_activeTable__gbNft:before,
.tr-styles_tdGroup__Qglm\\+.tr-styles_activeTable__gbNft:before {
    opacity: 0.05;
    background: #1650b4;
}

.tr-styles_tdGroupTable__UL8Ob td {
    position: relative;
    /*z-index: 1;*/
    padding: 20px 6px;
    width: 150px;
}

td:first-letter {
    text-transform: capitalize;
}

.tr-styles_tdGroupRow__UiP8p td {
    padding: 0 20px;
    max-width: 250px;
    min-width: 250px;
    width: 250px;
}

.tr-styles_activeHeader__HdM23 {
    color: var(--primary-color);
}

.tr-styles_activeHeader__HdM23:after {
    border-color: #1b53b1;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .tr-styles_tdGroupTable__UL8Ob td {
        padding: 0px 6px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ComparisonTable/components/tr-styles.module.css"],"names":[],"mappings":"AAEA,oBAAoB;AACpB,0BAA0B;AAC1B,uBAAuB;AACvB,mBAAmB;AACnB,6BAA6B;AAC7B,IAAI;;AAEJ;IACI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,wBAAwB;IACxB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,OAAO;IACP,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["@value screen-md-max from '../../../breakpoints.css';\n\n/*.rowExpandedImg {*/\n/*    text-align: center;*/\n/*    cursor: pointer;*/\n/*    width: 100%;*/\n/*    display: inline-block;*/\n/*}*/\n\n.tdInner {\n    display: flex;\n    text-align: left;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n    grid-gap: 6px;\n}\n\n.fixedRow {\n    position: sticky !important;\n    top: 28px;\n    z-index: 9;\n    background: var(--white-active);\n}\n\n.tdGroupTable {\n    position: relative;\n    padding: 20px;\n    width: 100%;\n    height: 100%;\n    min-width: 100%;\n    /*display: flex;*/\n    /*flex-direction: column;*/\n}\n\n.tdGroupRow {\n    position: relative;\n}\n\n.tdGroup {\n    position: relative;\n    padding: 0 10px;\n}\n\n.tdGroup:last-child {\n    padding-right: 0;\n}\n\n.tdGroup:last-child:before {\n    width: calc(100% - 10px);\n}\n\n.tdGroup:before,\n.tdGroupRow:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 10px;\n    width: calc(100% - 20px);\n    height: 100%;\n}\n\n.tdGroup:not(:first-child):before,\n.tdGroupRow:before {\n    opacity: 0.2;\n    background: var(--light-grey);\n}\n\n.tdGroupRow:first-child:before {\n    left: 0;\n    width: calc(100% - 10px);\n}\n\n.tdGroupRow:last-child:before {\n    width: calc(100% - 10px);\n}\n\n.tdGroupRow.activeTable:before,\n.tdGroup.activeTable:before {\n    opacity: 0.05;\n    background: #1650b4;\n}\n\n.tdGroupTable td {\n    position: relative;\n    /*z-index: 1;*/\n    padding: 20px 6px;\n    width: 150px;\n}\n\ntd:first-letter {\n    text-transform: capitalize;\n}\n\n.tdGroupRow td {\n    padding: 0 20px;\n    max-width: 250px;\n    min-width: 250px;\n    width: 250px;\n}\n\n.activeHeader {\n    color: var(--primary-color);\n}\n\n.activeHeader:after {\n    border-color: #1b53b1;\n}\n\n@media screen-md-max {\n    .tdGroupTable td {\n        padding: 0px 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"tdInner": `tr-styles_tdInner__erpMF`,
	"fixedRow": `tr-styles_fixedRow__qe41B`,
	"tdGroupTable": `tr-styles_tdGroupTable__UL8Ob`,
	"tdGroupRow": `tr-styles_tdGroupRow__UiP8p`,
	"tdGroup": `tr-styles_tdGroup__Qglm+`,
	"activeTable": `tr-styles_activeTable__gbNft`,
	"activeHeader": `tr-styles_activeHeader__HdM23`
};
export default ___CSS_LOADER_EXPORT___;
